export default "__VITE_ASSET__Ddq2Dcng__"